import { render } from "./story_publications.vue?vue&type=template&id=49dff0d0&lang=pug"
import script from "./story_publications.vue?vue&type=script&lang=js"
export * from "./story_publications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__